import React, { FC, useMemo } from 'react';
import { Typography } from '@mui/material';

export const ValueRangeLegend: FC<ValueRangeLegendProps> = ({ items }: ValueRangeLegendProps) => {
  const legend: LegendItem[] = useMemo(() => {
    return items.map((item: ValueRangeLegendItem) => {
      let value = '';
      const { from, to } = item;
      if (from !== null && to !== null) {
        value = `[${from} - ${to}]`;
      } else if (from !== null) {
        value = `> ${from}`;
      } else if (to !== null) {
        value = `< ${to}`;
      } else {
        value = 'N/A';
      }
      return { name: item.name, value: value, color: item.color };
    });
  }, [items]);

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1">
      {legend.map((item: LegendItem, index: number) => (
        <div key={index} className="flex items-center">
          <span
            className="mr-1.5 inline-block h-3 w-3 rounded-full"
            style={{ backgroundColor: item.color }}
          ></span>

          <Typography variant="body2" className="mr-1 font-medium">
            {item.name}:
          </Typography>
          <Typography variant="body2">{item.value}</Typography>
        </div>
      ))}
    </div>
  );
};

interface LegendItem {
  name: string;
  value: string;
  color: string;
}

export interface ValueRangeLegendItem {
  name: string;
  from: number | null;
  to: number | null;
  color: string;
}

interface ValueRangeLegendProps {
  items: ValueRangeLegendItem[];
}
